import { assign } from 'xstate';
import get from 'src/utils/lodash-alternatives';
import interpolate from './interpolate';
import { makeValidated } from './utils';
import saveSchema from '../schema/save.schema.json';
import logSchema from '../schema/log.schema.json';

export {
  initLayout,
  setLayoutProperty,
  mergeLayoutProperty,
  showLayoutComponent,
  hideLayoutComponent,
  batchLayoutOperations,
} from './actions-layout';

export const save = assign((context, event, meta) => {
  const validated = makeValidated(saveSchema);
  const { data } = validated(
    interpolate(
      {
        type: 'save',
        data: get(meta, 'action.data'),
        meta: get(meta, 'action.meta'),
      },
      event,
      context
    )
  );
  return Object.assign({}, context, data);
});

export const log = (context, event, meta) => {
  const isPrimitive = value => typeof value !== 'object';
  const isShallowObjectOfPrimitives = value =>
    !Array.isArray(value) &&
    typeof value === 'object' &&
    Object.keys(value).every(key => isPrimitive(value[key]));
  const isDisplayableAsTable = value =>
    (Array.isArray(value) && value.every(isPrimitive)) ||
    (Array.isArray(value) && value.every(isShallowObjectOfPrimitives)) ||
    isShallowObjectOfPrimitives(value);
  const logValue = (label, value, logFn) => {
    if (label !== undefined) {
      console.group(label);
      logFn(value);
      console.groupEnd();
    } else {
      logFn(value);
    }
  };
  const validated = makeValidated(logSchema);
  const {
    data: { label, value, table },
  } = validated(interpolate(meta.action, event, context));

  logValue(
    label,
    value,
    table === true || (table !== false && isDisplayableAsTable(value))
      ? console.table
      : console.log
  );
};
